export function Tooltip({ label, children, side = 'end' }) {
  if (!label) {
    return children;
  }
  return (
    <span className={`ds-tooltip ds-tooltip-${side}`}>
      {children}
      <span className="ds-tooltip-label" aria-hidden="true">{label}</span>
    </span>
  );
}
